<template>
  <div>
    <div class="columns is-gapless is-vcentered is-border-bottom has-bg-light is-min-height-50">
      <div class="column is-padding-left">
        <span class="is-size-6">{{sourceContactsTotal}} Contact(s)</span>
      </div>
      <div class="column is-narrow is-border-left is-self-stretched">
        <router-link :to="{name: 'ContactCreate', query: {seller: user.pk}}"
          class="button is-min-width-0 is-radiusless is-small is-light is-min-height-full has-text-grey has-text-normal">
          <span class="icon"><i class="fal fa-user-plus"></i></span>
          <span>Créer un contact</span>
        </router-link>
      </div>
    </div>
    <table class="table is-fullwidth is-marginless-bottom is-radius-bottom-left is-radius-bottom-right" v-if="contacts && contacts.length">
      <thead>
      <tr class="is-size-6">
        <th>Contact(s)</th>
        <th>Email</th>
        <th>Téléphone</th>
        <th>Ville</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(contact, i) in contacts" :key="contact.pk" class="is-size-6 is-radius-bottom-left">
        <td class="is-cell-hoverable">
          <router-link :to="{name: 'ContactVue', params: {id: contact.pk}}" class="fullLink">
            <avatar :item="contact" :i="i" class="is-margin-right-xsmall"></avatar>
            <span>{{contact.last_name}} {{contact.first_name}}</span>
          </router-link>
        </td>
        <td><span v-if="contact.email">{{contact.email}}</span><span v-else>--</span></td>
        <td><span v-if="contact.phone">{{contact.phone}}</span><span v-else>--</span></td>
        <td><span v-if="contact.address && contact.address.city">{{contact.address.city}}</span><span v-else>--</span></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'UserContactList',
  props: {
    sourceContacts: {
      type: Array,
      required: true,
      default: []
    },
    sourceContactsTotal: {
      type: Number,
      default: 0
    },
    sourceUser: Object
  },
  computed: {
    contacts () {
      return this.sourceContacts
    },
    user () {
      return this.sourceUser
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/UserVuePanel/UserContactList.vue